import { useNavigation } from "@react-navigation/native";
import React, { useEffect, useState } from "react";
import { Pressable, View } from "react-native";
import PaymentSuccess from "@assets/svg/PaymentSuccess";
import colors from "@constants/color";
import entityStyle from "@utils/entityStyle";
import FillAddress from "@assets/svg/FillAddress";
import AsyncStorage from "@react-native-async-storage/async-storage";
import t from "@constants/localization";
import analytics from "@services/analytics";
import { LEADER_STATES } from "@screens/Home/ClPaymentAndAddress";
import CustomText from "./CustomText";

const PATH = "screens/Home/Payment/PaymentRecieved";

const PaymentRecievedView = ({ user = {} }) => {
  const navigation = useNavigation();
  const [showPaymentSuccess, setShowPaymentSuccess] = useState(false);

  useEffect(() => {
    if (user.leader_state === LEADER_STATES.PAYMENT_DONE) {
      AsyncStorage.getItem("payment_done").then((data) => {
        if (!data) {
          setShowPaymentSuccess(true);
          AsyncStorage.setItem("payment_done", "true");
        }
      });
    }
  }, [user.leader_state]);

  const fillAddress = () => {
    analytics.trackEvent("Address modal clicked", {
      leader_state: user.leader_state,
      source: "card",
    });
    navigation.navigate("TLAddress", {
      source: "payment_flow",
    });
  };

  return (
    <>
      {showPaymentSuccess && <PaymentRecieved />}
      {!user.address1 && (
        <CompleteAddress handleModalVisibility={fillAddress} />
      )}
    </>
  );
};

const PaymentRecieved = () => {
  return (
    <View
      style={[
        entityStyle.entityContainer,
        {
          borderRadius: 10,
          overflow: "hidden",
          position: "relative",
          elevation: 1,
          marginBottom: 10,
          backgroundColor: "white",
          borderWidth: 1,
          borderColor: "#00AB59",
        },
      ]}
    >
      <View
        style={{
          flexDirection: "row",
          padding: 16,
          backgroundColor: "rgba(0, 171, 89, 0.04)",
        }}
      >
        <View
          style={{
            backgroundColor: "tranparent",
            paddingTop: 10,
          }}
        >
          <PaymentSuccess />
        </View>
        <View>
          <View
            style={{
              paddingTop: 16,
              justifyContent: "center",
            }}
          >
            <CustomText
              bold
              variant="entityHeading"
              style={{
                fontSize: 16,
                color: colors.black,
                lineHeight: 22,
              }}
            >
              {t(`${PATH}/recieved`)}
            </CustomText>
          </View>
          <View
            style={{
              paddingHorizontal: 16,
              paddingRight: 70,
            }}
          >
            <CustomText
              bold
              fontType="content1"
              style={{
                fontSize: 14,
                color: colors.black,
                lineHeight: 22,
              }}
            >
              {t(`${PATH}/feedback`)}
            </CustomText>
          </View>
        </View>
      </View>
    </View>
  );
};

const CompleteAddress = ({ handleModalVisibility = () => {} }) => {
  return (
    <View
      style={[
        entityStyle.entityContainer,
        {
          borderRadius: 10,
          overflow: "hidden",
          position: "relative",
          marginBottom: 10,
          backgroundColor: "rgba(255, 255, 255, 0.3)",
          borderWidth: 1,
          borderColor: "rgba(0, 0, 0, 0.3)",
        },
      ]}
    >
      <View
        style={{
          padding: 16,
          backgroundColor: "rgba(255, 255, 255, 0.3)",
        }}
      >
        <View>
          <View
            style={{
              justifyContent: "center",
              marginBottom: 8,
            }}
          >
            <CustomText
              variant="body_text_1"
              style={{
                color: colors.black,
              }}
            >
              {t(`${PATH}/completeAddress`)}
            </CustomText>
          </View>
          <View
            style={{
              flexDirection: "row",
            }}
          >
            <View style={{ flex: 1 }}>
              <FillAddress />
            </View>
            <Pressable
              style={{
                paddingVertical: 12,
                marginBottom: 0,
                backgroundColor: "#E40046",
                borderRadius: 6,
                alignItems: "center",
                flex: 1,
              }}
              onPress={handleModalVisibility}
            >
              <CustomText
                bold
                variant="entityHeading"
                style={{
                  color: "white",
                  marginBottom: 0,
                }}
              >
                {t(`${PATH}/addAddress`)}
              </CustomText>
            </Pressable>
          </View>
        </View>
      </View>
    </View>
  );
};

export default PaymentRecievedView;
